<template>
  <div>
    <div
      style="display: flex;flex-direction: row;align-items: stretch;"
      class="mb-4"
    >
      <el-form
        ref="form"
        size="small"
        :model="formData"
        :rules="rules"
        :validate-on-rule-change="false"
        label-position="top"
        style="flex-grow: 1;"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_reviewType') || '审批结果'"
              prop="reviewType"
            >
              <el-radio-group v-model="formData.reviewType">
                <el-radio label="A">
                  {{ $l('INDEX.btn_approved') || '通过' }}
                </el-radio>
                <el-radio label="R">
                  {{ $l('INDEX.btn_rejected') || '驳回' }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_approvalComment') || '审批意见'"
              prop="approvalComment"
              style="margin-bottom: 0 !important;"
            >
              <el-input
                v-model="formData.approvalComment"
                :placeholder="$l('form_placeholder_approvalComment') || '请输入审批意见'"
                type="textarea"
                :maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="display: flex;align-items: flex-end;">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </div>
    </div>

    <ReviewContent :businessType="businessType" :businessCode="businessCode" />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      v-if="backDialogVisible"
      :visible.sync="backDialogVisible"
      width="30%"
      @close="() => (backDialogVisible = false)"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ReviewContent from './content.vue'
export default {
  components: { ReviewContent },
  mixins: [EditLoading],
  props: {
    bflowTaskCode: { type: String, default: '' },
    businessType: { type: String, default: '' },
    businessCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { reviewType: '', approvalComment: '' },
    }
  },
  computed: {
    isApproved() {
      return lodash.isEqual(this.formData.reviewType, 'A')
    },
    rules() {
      return {
        reviewType: [
          {
            required: true,
            message: this.$l('form_placeholder_reviewType') || '请选择审批结果',
            trigger: 'blur',
          },
        ],
        approvalComment: [
          {
            required: !this.isApproved,
            message:
              this.$l('form_placeholder_approvalComment') || '请输入审批意见',
            trigger: 'change',
          },
        ],
      }
    },
  },
  mounted() {},
  methods: {
    confirmApi() {
      return this.isApproved
        ? this.$api.approvalCenterTodoApproveApi
        : this.$api.approvalCenterTodoRejectApi
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.confirmApi()({
        ...this.formData,
        bflowTaskCode: this.bflowTaskCode,
      }).catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        return this.$message.error(
          msg || this.$l('INDEX.tips_audit_failure') || '审批失败'
        )
      }

      this.$message({
        showClose: true,
        message: msg || this.$l('INDEX.tips_audit_success') || '审批成功',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.image_div {
  border: 1px solid #ebeef5;
  border-right: none;
}

.sku_main {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  // height: 49px;
  // line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side_frame_div {
  height: 25px;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
